import type { IconData } from '@stacksjs/iconify-core'

export const arrowThickFromBottom: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M256.2 16L56 215.993v38.632h120v144h160v-144h120V216ZM304 222.625v144h-96v-144H94.639L256.174 61.254l161.21 161.371Zm-248 240h400v32H56z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default arrowThickFromBottom
